module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_italy_cn.11d26688.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_italy_cn.png
// module id = 1098
// module chunks = 16